import gql from 'graphql-tag';

const projectQueries = {

    allProjectStatus: gql`
        query Projectstatuss {
            projectstatuss(count: 100, orderBy: [{ field: "name", order: ASC }]) {
                data {
                    id
                    name
                    color
                    prio
                    closed
                    default
                    event
                    projects{
                        id
                    }
                }
            }
        }
    `,

    getProjectStatus: gql`
        query ProjectStatus($event: String) {
            projectstatus(event:$event) {
                id
                name
                color
                prio
                closed
                default
                event
            }
        }
    `,

    findProject: gql`
        query FindProjects($name: String) {
          findProjects(count: 10, name: $name) {
            data {
              id
              name
            }
          }
        }
    `,

    getOpenProjects: gql`
        query FindProjects($name: String, $status_id: [Int!]) {
            findProjects(
                count:6
                name: $name
                status_id: $status_id
                orderBy: [
                    { field : "name", order : ASC },
                ]
            ){
                data{
                    id
                    name
                    number_internal
                    first_grace_period
                    second_grace_period
                }
            }
        }
    `,

    getOpenProjectsByNumber: gql`
        query FindProjectsByNumber($name: String, $status_id: [Int!]) {
            findProjectsByNumber(
                count:10
                number_internal: $name
                status_id: $status_id
                orderBy: [
                    { field : "number_internal", order : ASC },
                ]
            ){
                data{
                    id
                    name
                    number_internal
                    number_client
                    first_grace_period
                    second_grace_period
                    buildings {
                        building {
                            name
                            street
                            number
                            parent {
                                name
                                street
                                number
                                zip
                                city
                                builder {
                                    id
                                    company_name
                                    type_of_relation
                                    email
                                }
                            }
                        }
                        apartment {
                            number
                            storey
                            tenant_name
                            tenant_phone_number
                        }
                    }

                    contacts {
                        contact {
                            company_name
                            street
                            number
                            zip
                            city
                        }
                    }

                    emails {
                        to
                        type
                        sent_at
                    }

                    owner {
                        name
                    }
                }
            }
        }
    `,

    getSubProjects: gql`query Projects($parent_id: Int!) {
        projects(
            count      : 9999 # paginator
            parent_id : $parent_id    # where
            orderBy    : [
                { field : "name", order : ASC },
            ]
        ){
            data {
                id
                name
                status {
                    id
                    name
                    color
                }
                owner {
                    id
                    name
                }
            }
        } }`
    ,

};

export default projectQueries;
